<template>
  <v-container class="py-0">
    <TitleWidget :small="smAndDown" dark>
      {{ title }}
    </TitleWidget>

    <div class="d-flex justify-center flex-wrap mt-4 mt-lg-6 categories">
      <v-btn
        v-for="({ text, to }, keyCategories) in categories"
        :key="keyCategories"
        class="
          white--text
          text-caption text-md-body-2 text-lg-subtitle-1 text-none
          font-weight-medium
          px-2
        "
        :to="to"
        color="rgba(33, 25, 21, 0.60)"
        :small="smAndDown"
        depressed
      >
        {{ text }}
      </v-btn>
    </div>

    <v-sheet
      v-if="!smAndDown"
      class="pa-4 pa-lg-6 mt-4 mt-lg-6"
      color="primary"
    >
      <SearchHomeForm dark />
    </v-sheet>
  </v-container>
</template>

<script>
import TitleWidget from "./TitleWidget.vue";
import SearchHomeForm from "../forms/SearchHomeForm.vue";

const _data = {
  title: "Procurando um Imóvel?",
  path: "/imoveis",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    categories() {
      const categories = [
        "Apartamento",
        "Casa",
        "Casa em Condomínio",
        "Sala Comercial",
        "Terreno",
        "Terreno Comercial",
      ];

      return this.$rest("categories")
        .list.filter((item) => categories.includes(item))
        .map((item) => {
          if (["Terreno", "Terreno Comercial"].includes(item))
            return {
              text: item,
              to:
                "/terrenos" +
                (item === "Terreno Comercial" ? "?tipo=Terreno Comercial" : ""),
            };

          return {
            text: item,
            to: `${this.path}?tipo=${item}`,
          };
        });
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$rest("categories").get();
  },
  components: {
    TitleWidget,
    SearchHomeForm,
  },
};
</script>

<style lang="scss" scoped>
.categories {
  gap: 12px;
}
</style>
